<template>
  <div id="app">
    <router-view />
    <div class="bottom">
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备16036852号</a>
    </div>
  </div>
  <!-- <nav> -->
    <!-- <router-link to="/">Home</router-link> | -->
    <!-- <router-link to="/about">About</router-link> -->
  <!-- </nav> -->
  <!-- <router-view/> -->
</template>

<style lang="scss">
html,
body,
#app {
  margin: 0;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.bottom {
  position: fixed;
  bottom: 0px;
  display: flex;
  width: 100%;
  justify-content: center;
  color: #646cff;
  z-index: 999;
}

nav {
  // padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
